<div>
  <div class="tw-text-lg tw-font-semibold tw-flex tw-items-center">
    {{ heading }}
    <mat-icon
      [matTooltip]="tooltipText"
      class="tw-ml-1"
      >info</mat-icon
    >
  </div>

  <div class="tw-text-base tw-m-1">※改行、またはカンマ区切りで複数指定</div>
  <div class="tw-mt-4">
    @if (!updating) {
      <div class="tw-m-1">
        {{ this.backupEmailStr }}
      </div>
    } @else {
      <div>
        <mat-form-field
          appearance="outline"
          floatLabel="always"
          class="tw-w-[700px]"
        >
          <mat-label>メールアドレス</mat-label>
          <textarea
            matInput
            [formControl]="formGroup.controls['backupEmail']"
            rows="5"
          ></textarea>
        </mat-form-field>
      </div>
    }
  </div>
  <div>
    <div class="matp-table-actions">
      @if (!updating) {
        <button
          mat-raised-button
          id="edit-mode-btn"
          color="primary"
          type="button"
          class="tw-w-28 tw-mt-20"
          (click)="toggleUpdating()"
        >
          <mat-icon>edit</mat-icon>
          編集
        </button>
      } @else {
        <button
          mat-raised-button
          class="tw-w-40 tw-mt-4"
          *ngIf="updating"
          (click)="cancelEditing()"
        >
          <mat-icon>close</mat-icon>
          キャンセル
        </button>
        <button
          mat-raised-button
          id="edit-btn"
          color="accent"
          type="submit"
          class="tw-w-40 tw-ml-2 tw-mt-4"
          (click)="updateBackupEmail()"
        >
          <mat-icon>done</mat-icon>
          編集内容保存
        </button>
      }
    </div>
  </div>
</div>
